import React, { useState, useEffect } from 'react';
import apiUrl from '../Apiurl';
import prodVuoto from '../prodottoVuoto';
import { useAuth0 } from '@auth0/auth0-react';

function CodicePSVoceCliccabile({codVS,codPS,codProd,shortName,titIT,brand,setProductFunction,setIDPSdiverso,utente}) {
  

    
    const { user, /* isAuthenticated,  */getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");

    const codPStrovatoOppureNo = function(oggRisposta){
      if (oggRisposta && oggRisposta.idPSdiversoTrovato) {
        setIDPSdiverso({
          idPSdiversoTrovato: oggRisposta.idPSdiversoTrovato,
          idAttuale: codPS
        });
      } else {
        console.log("oggRisposta.risultatoRicerca",oggRisposta.risultatoRicerca)
        setProductFunction(oggRisposta.risultatoRicerca[0] || prodVuoto)
      }
    }

    let url;

    if (codVS) {
      url = codVS
    } else {
      url = "NULL"
    }

    if (codPS) {
      url = url+"/"+codPS
    } else {
      url = url+"/"+"NULL"
    }

    if (codProd) {
      url = url+"/"+codProd
    } else {
      url = url+"/"+"NULL"
    }

    if (shortName) {
      url = url+"/"+shortName
    } else {
      url = url+"/"+"NULL"
    }

    if (titIT) {
      url = url+"/"+titIT
    } else {
      url = url+"/"+"NULL"
    }

    if (brand) {
      url = url+"/"+brand
    } else {
      url = url+"/"+"NULL"
    }


    useEffect(() => {
        const getUserMetadata = async () => {
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
        getUserMetadata();
      }, [getAccessTokenSilently, user?.sub]);
    
    
      const handleSubmit = (e) => {
        if (!token) {
          console.warn("sto aspettando un token")
          return;
        }
        if (!utente.permessiAPI["update:database"] && utente.permessiAPI["update:dbrevisioni"]) {
          fetch(apiUrl + "/prodotti/prodotto/showORcreateIDPSREVfromPS/"+url, { headers: { Authorization: "Bearer " + token } })
          .then(resp => resp.json())
          .then(data => codPStrovatoOppureNo(data))
          .then(e.preventDefault())
        } else if (utente.permessiAPI["update:database"]) {
          fetch(apiUrl + "/prodotti/prodotto/showORcreateIDPSfromPS/"+url, { headers: { Authorization: "Bearer " + token } })
          .then(resp => resp.json())
          .then(data => codPStrovatoOppureNo(data))
          .then(e.preventDefault())
        }        
      }


    return(
        <span className="pointer codPScliccabile" onClick={handleSubmit}>
            <strong>{codPS}</strong>            
        </span>   
    )
}


export default CodicePSVoceCliccabile;



